import type { FetchConfigurablesArgs } from './types/configurables.types';
import type {
  ApiConfigurable,
  UiConfigurable,
} from '../schemas/configurables.schema';
import type { BaseApiPaginatedResponse } from './types/api.types';

import { mapConfigurableFromApi } from './mappers/configurables.mappers';
import { get } from './axios';

export const fetchConfigurables = async ({
  filters,
  isMandatory,
}: FetchConfigurablesArgs) => {
  const response = await get<BaseApiPaginatedResponse<ApiConfigurable[]>>(
    `/v2/configurables`,
    {
      query: {
        ...filters,
        ...(isMandatory !== undefined
          ? { isMandatory: String(isMandatory) }
          : {}),
      },
    },
  );
  return {
    ...response,
    data: response?.data?.map(mapConfigurableFromApi) as UiConfigurable[],
  };
};
